var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CDA64",
    d: "M15.0009,3.1474C12.2972,3.1474 10.1053,5.2732 10.1053,7.8954C10.1053,10.5176 12.2972,12.6434 15.0009,12.6434C17.7047,12.6434 19.8965,10.5176 19.8965,7.8954C19.8965,5.2732 17.7047,3.1474 15.0009,3.1474ZM7.6575,7.8954C7.6575,3.962 10.9453,0.7734 15.0009,0.7734C19.0566,0.7734 22.3443,3.962 22.3443,7.8954C22.3443,11.8288 19.0566,15.0174 15.0009,15.0174C10.9453,15.0174 7.6575,11.8288 7.6575,7.8954Z",
    fillRule: "evenodd",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CDA64",
    d: "M14.9999,19.6905C12.4697,19.6905 9.9956,20.4135 7.8865,21.7692C5.7775,23.1249 4.1271,25.0533 3.1415,27.3133C2.8782,27.9171 2.16,28.1995 1.5375,27.9442C0.915,27.6888 0.6237,26.9923 0.887,26.3886C2.0601,23.6988 4.0243,21.4039 6.5342,19.7904C9.0442,18.177 11.9887,17.3165 14.9999,17.3165C18.0111,17.3165 20.9556,18.177 23.4655,19.7904C25.9755,21.4039 27.9396,23.6988 29.1126,26.3886C29.3759,26.9923 29.0847,27.6888 28.4622,27.9442C27.8396,28.1995 27.1215,27.9171 26.8582,27.3133C25.8725,25.0533 24.2222,23.1249 22.1132,21.7692C20.0042,20.4135 17.5301,19.6905 14.9999,19.6905Z",
    fillRule: "evenodd",
    id: "path_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.26f048afcb5f4857c79bb02f62a604b4.svg";
export { ForwardRef as ReactComponent };